module.exports = __webpack_public_path__ + "static/media/Login_Image.1db90625.png";